import React from "react";
import Page from "../../components/Page";
import HomeCard from "./Components/HomeCard";
import { useNavigate } from "react-router-dom";
import { useRef, useEffect } from "react";
import { lookForAtom } from "../../components/ProjectFilters/ProjectFilters";
import { useSetAtom } from "jotai";
import { useState } from "react";

const Home = () => {
  const navigate = useNavigate();
  const searchInputRef = useRef<HTMLInputElement>(null);
  const setLookFor = useSetAtom(lookForAtom);
  const [lookForValue, setLookForValue] = useState<'projects' | 'teammates'>('projects');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = () => {
    const value = searchInputRef.current?.value || "";
    localStorage.setItem("searchText", value);
    localStorage.setItem("searchTab", lookForValue);
    setLookFor(lookForValue);
    navigate("/find");
  };
  return (
    <Page>
      <section className="home">
        <div className="home__container">
          <div className="home__content">
            <div className="home__header">
              <p>Welcome to</p>
              <h3>
                Slinge<b>rr</b>
              </h3>
              <span>Your projects home</span>
            </div>
            <div className="home__search-section">
              <div className="search-container" ref={dropdownRef}>
                <span className="search-label">I Look for</span>
                <div
                  className="dropdown-select"
                  onClick={() => setDropdownOpen((open) => !open)}
                >
                  {lookForValue === 'teammates' ? 'Teammate' : 'Project'}
                  <span className="dropdown-arrow">
                    <svg width="18" height="18" fill="gray" xmlns="http://www.w3.org/2000/svg"><path d="M4 6l5 5 5-5" stroke="#888" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>
                  </span>
                  {dropdownOpen && (
                    <div className="dropdown-menu">
                      <div
                        className={`dropdown-item ${lookForValue === 'teammates' ? 'active' : ''}`}
                        onClick={() => { setLookForValue('teammates'); setDropdownOpen(false); }}
                      >Teammate</div>
                      <div
                        className={`dropdown-item ${lookForValue === 'projects' ? 'active' : ''}`}
                        onClick={() => { setLookForValue('projects'); setDropdownOpen(false); }}
                      >Project</div>
                    </div>
                  )}
                </div>
              </div>
              <input
                ref={searchInputRef}
                className='search-input'
                type="text"
                placeholder="Write what you want to build, who do you need, what skills, whatever..."
                onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
              />
              <button
                className="search-button"
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Home;
